import React, { useState,useEffect } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import "./style.css";
import { useGetReferralIncomeSummaryQuery,useGetReferralLifetimeIncomeSummaryQuery,useGetReferralYesterdayIncomeSummaryQuery } from "../../features/api/userApiSlice";
import { useTranslation } from "react-i18next";

const CardSummary = ({ title, data }) => {
  return (
    <div className="card">
      <h3>{title}</h3>
      {data.map((item, index) => (
        <p key={index}>
          <strong>{item.label}:</strong>
          <span className="value">{item.value}</span>
        </p>
      ))}
    </div>
  );
};

const CardDetails = ({ title, data }) => {
  return (
    <div className="cardDetails">
      <h3>{title}</h3>
      {data.map((item, index) => (
        <p key={index}>
          <strong>{item.label}: </strong>
          <span className="value">{item.value}</span>
        </p>
      ))}
    </div>
  );
};

const Income = () => {

    const [tab, setTab] = useState(0);
    const { t } = useTranslation();

     const {
      data: referralIncomeSummary,
      isLoading: isReferralIncomeSummaryLoading,
      isError: isReferralIncomeSummaryError,
      isSuccess: isReferralIncomeSummarySuccess,
      error: referralIncomeSummaryError,
    } = useGetReferralIncomeSummaryQuery();

    const {
      data: referralLifetimeIncomeSummary,
      isLoading: isReferralLifetimeIncomeSummaryLoading,
      isError: isReferralLifetimeIncomeSummaryError,
      isSuccess: isReferralLifetimeIncomeSummarySuccess,
      error: referralLifetimeIncomeSummaryError,
    } = useGetReferralLifetimeIncomeSummaryQuery();

    const {
      data: referralYesterdayIncomeSummary,
      isLoading: isReferralYesterdayIncomeSummaryLoading,
      isError: isReferralYesterdayIncomeSummaryError,
      isSuccess: isReferralYesterdayIncomeSummarySuccess,
      error: referralYesterdayIncomeSummaryError,
    } = useGetReferralYesterdayIncomeSummaryQuery();
  
  //   useEffect(() => {
  //   if (referralIncomeSummary) {
  //     console.log("Referral Income Summary:", referralIncomeSummary);
  //     console.log("Referral Yesterday Income Summary:", referralYesterdayIncomeSummary);
  //     console.log("Referral Lifetime Income Summary:", referralLifetimeIncomeSummary);
  //   }
  // }, [referralIncomeSummary,referralYesterdayIncomeSummary,referralLifetimeIncomeSummary]);
  
   if (isReferralIncomeSummaryLoading||isReferralLifetimeIncomeSummaryLoading||isReferralYesterdayIncomeSummaryLoading) return <div>Loading...</div>;

    const cardsData = [
  {
    title: t("referral.todayreferralincome"),
    data: [
      { label: t("referral.todaynewregistration"), value: referralIncomeSummary?.result?.todayRegister ?? 0 },
      { label: t("referral.todaydepositors"), value: referralIncomeSummary?.result?.todayDepositors ?? 0 },
      { label: t("referral.todayreferralbonus"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.todayReferralBonus ?? 0).toLocaleString()}`},
      { label: t("referral.todayreferralcommission"), value:`${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.todayReferralCommission ?? 0).toLocaleString()}`},
    ],
  },
  {
    title: t("referral.totalreferralincome"),
 data: [
      { label: t("referral.totalnewregistration"), value: referralIncomeSummary?.result?.totalRegister ?? 0 },
      { label: t("referral.totaldepositors"), value: referralIncomeSummary?.result?.totalDepositors ?? 0 },
      { label: t("referral.totalreferralbonus"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.totalReferralBonus ?? 0).toLocaleString()}`},
      { label: t("referral.totalreferralcommission"), value:`${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.totalReferralCommission ?? 0).toLocaleString()}`},
    ],
  },
  ];

  const detailedData = [
 {
    title: t("referral.yesterdayreferralbonus") + `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralYesterdayIncomeSummary?.result?.yesterdayReferralBonusAmount ?? 0).toLocaleString()}`,
    data: [
      { label: t("referral.yesterdayregister"), value: referralYesterdayIncomeSummary?.result?.yesterdayRegister ?? 0 },
      { label: t("referral.yesterdaydepositamount"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.yesterdayDepositAmount ?? 0).toLocaleString()}` },
    ],
  },
  {
    title: t("referral.yesterdaydirectreferralcommission")+ ` ${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralYesterdayIncomeSummary?.result?.yesterdayDirectReferralCommissionAmount ?? 0).toLocaleString()}`,
 data: [
      { label: t("referral.yesterdaynewdirectmember"), value: referralIncomeSummary?.result?.yesterdayDirectMember ?? 0 },
      { label: t("referral.yesterdaydirectmemberdeposit"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.yesterdayDirectMemberDeposit ?? 0).toLocaleString()}` },
      { label: t("referral.yesterdaydirectmembervalidbet"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.yesterdayDirectMemberValidBet ?? 0).toLocaleString()}`},
      { label: t("referral.yesterdaydirectmemberwinloss"), value:`${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.yesterdayDirectMemberWinLoss ?? 0).toLocaleString()}`},
    ],
  },
   {
   title: t("referral.yesterdayteamreferralcommission")+ ` ${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralYesterdayIncomeSummary?.result?.yesterdayTeamReferralCommissionAmount ?? 0).toLocaleString()}`,
 data: [
      { label: t("referral.yesterdaynewteammember"), value: referralIncomeSummary?.result?.yesterdayTeamMember ?? 0 },
      { label: t("referral.yesterdayteamdeposit"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.yesterdayTeamDeposit ?? 0).toLocaleString()}` },
      { label: t("referral.yesterdayteamvalidbet"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.yesterdayTeamValidBet ?? 0).toLocaleString()}`},
      { label: t("referral.yesterdayteamwinloss"), value:`${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.yesterdayTeamWinLoss ?? 0).toLocaleString()}`},
    ],
  },
  {
    title: t("referral.totalreferralbonus") + `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralIncomeSummary?.result?.totalReferralBonus ?? 0).toLocaleString()}`,
 data: [
      { label: t("referral.totalregister"), value: referralLifetimeIncomeSummary?.result?.totalRegister ?? 0 },
      { label: t("referral.totaldepositamount"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalDepositAmount ?? 0).toLocaleString()}` },
    ],
  },
  {
    title: t("referral.totaldirectreferralcommission")+ ` ${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalDirectReferralCommission ?? 0).toLocaleString()}`,
 data: [
      { label: t("referral.totaldirectmember"), value: referralLifetimeIncomeSummary?.result?.totalDirectMember ?? 0 },
      { label: t("referral.totaldirectmemberdeposit"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalDirectMemberDeposit ?? 0).toLocaleString()}` },
      { label: t("referral.totaldirectmembervalidbet"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalDirectMemberValidBet ?? 0).toLocaleString()}`},
      { label: t("referral.totaldirectmemberwinloss"), value:`${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalDirectMemberWinLoss ?? 0).toLocaleString()}`},
    ],
  },
   {
   title: t("referral.totalteamreferralcommission")+ ` ${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalTeamReferralCommission ?? 0).toLocaleString()}`,
 data: [
      { label: t("referral.totalnewteammember"), value: referralLifetimeIncomeSummary?.result?.totalTeamMember ?? 0 },
      { label: t("referral.totalteamdeposit"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalTeamDeposit ?? 0).toLocaleString()}` },
      { label: t("referral.totalteamvalidbet"), value: `${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalTeamValidBet ?? 0).toLocaleString()}`},
      { label: t("referral.totalteamwinloss"), value:`${process.env.REACT_APP_CURRENCY_CODE} ${Number(referralLifetimeIncomeSummary?.result?.totalTeamWinLoss ?? 0).toLocaleString()}`},
    ],
  },
];

    const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box sx ={{mb:10}}>
      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={handleTabChange}
        centered
        sx={{ mt: 1 ,mb: 2, backgroundColor: "#f5f5f5", borderRadius: 1 }}
      >
        <Tab label="Summary" />
        <Tab label="Details" />
      </Tabs>

      {/* Tab Content */}
      {tab === 0 && (
        <div className="card-container">
          {cardsData.map((card, index) => (
            <CardSummary key={index} title={card.title} data={card.data} />
          ))}
        </div>
      )}

      {tab === 1 && (
        <Box className="card-container">
        <div className="card-container">
          {detailedData.map((card, index) => (
            <CardDetails key={index} title={card.title} data={card.data} />
          ))}
        </div>
        </Box>
      )}
    </Box>
  );
};

export default Income;
